import { render, staticRenderFns } from "./CookieBlock.vue?vue&type=template&id=45b151de"
import script from "./cookieBlock.ts?vue&type=script&lang=js&external"
export * from "./cookieBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports